// Frontend-эквивалент app.services.analytics.resolve_period.
// PeriodPicker отдаёт ключ ("today" / "yesterday" / "this_week" / …),
// здесь переводим его в пару (ISO start, ISO end).

function iso(d: Date): string {
  // Не дёргаем toISOString (он сдвигает в UTC и при смене дат может
  // подменить день). Считаем «локальную» дату вручную.
  const pad = (n: number) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

export function resolvePeriod(
  key: string,
  customStart: string | null = null,
  customEnd: string | null = null,
  now: Date = new Date(),
): [string | undefined, string | undefined] {
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const addDays = (d: Date, n: number) => {
    const r = new Date(d);
    r.setDate(d.getDate() + n);
    return r;
  };

  if (key === "custom") {
    if (customStart && customEnd) return [customStart, customEnd];
    return [undefined, undefined];
  }
  if (key === "today") {
    return [iso(today), iso(today)];
  }
  if (key === "yesterday") {
    const y = addDays(today, -1);
    return [iso(y), iso(y)];
  }
  if (key === "this_week") {
    // ISO неделя: понедельник=0…воскресенье=6. JS: вск=0…сб=6.
    const dow = (today.getDay() + 6) % 7;
    return [iso(addDays(today, -dow)), iso(today)];
  }
  if (key === "last_week") {
    const dow = (today.getDay() + 6) % 7;
    const end = addDays(today, -dow - 1); // воскресенье прошлой недели
    const start = addDays(end, -6);       // понедельник прошлой недели
    return [iso(start), iso(end)];
  }
  if (key === "this_month") {
    const s = new Date(today.getFullYear(), today.getMonth(), 1);
    return [iso(s), iso(today)];
  }
  if (key === "last_month" || key === "prev_month") {
    const s = new Date(today.getFullYear(), today.getMonth() - 1, 1);
    const e = new Date(today.getFullYear(), today.getMonth(), 0); // последний день прошлого
    return [iso(s), iso(e)];
  }
  if (key === "this_quarter") {
    const q = Math.floor(today.getMonth() / 3);
    const s = new Date(today.getFullYear(), q * 3, 1);
    return [iso(s), iso(today)];
  }
  // Неизвестный ключ — без фильтра (всё время).
  return [undefined, undefined];
}
